class BrandsDirectory extends HTMLElement {
  connectedCallback() {
    this.search = this.querySelector('[data-brand-search]');
    this.buttons = [...this.querySelectorAll('.brands-directory__letter')];
    this.items = [...this.querySelectorAll('[data-brand-name]')];
    this.count = this.querySelector('[data-brand-count]');
    this.empty = this.querySelector('[data-brand-empty]');
    this.activeLetter = 'all';

    this.search?.addEventListener('input', () => this.filter());

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeLetter = button.dataset.brandLetter;
        this.buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        this.filter();
      });
    });
  }

  filter() {
    const query = this.search?.value.trim().toLocaleLowerCase() || '';
    let visible = 0;

    this.items.forEach((item) => {
      const matchesLetter = this.activeLetter === 'all' || item.dataset.brandLetter === this.activeLetter;
      const matchesSearch = item.dataset.brandName.toLocaleLowerCase().includes(query);
      const show = matchesLetter && matchesSearch;
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (this.count) this.count.textContent = `${visible} ${visible === 1 ? 'brand' : 'brands'}`;
    if (this.empty) this.empty.hidden = visible !== 0;
  }
}

if (!customElements.get('brands-directory')) customElements.define('brands-directory', BrandsDirectory);
